export function initMainNav() {

    /***********************
     * DOM elements
     */

    const mainTrigger = document.getElementById('menu_trigger');
    const mainNavBar = document.getElementById('main_nav');

    /***********************
     * Globals
     */

    let subMenuActive = null;
    const homeHeader = document.querySelector('body > header.--home');

    /***********************
     * Handlers
     */

    function toggleMenu(isOpen) {

        document.body.classList.toggle('menu-active', !isOpen);

        mainTrigger.setAttribute('aria-expanded', String(!isOpen));
        mainTrigger.setAttribute(
            'aria-label',
            isOpen ? 'Ouvrir le menu' : 'Fermer le menu'
        );

        mainNavBar.setAttribute('aria-hidden', String(isOpen));

        setTimeout(() => {

            mainNavBar.classList.toggle('draw-lines', !isOpen);

        }, isOpen ? 0 : 850);

        requestAnimationFrame(() => {

            requestAnimationFrame(() => {

                document.dispatchEvent(new Event('links:refresh'));

            });

        });

        // Sécurité : le calcul ci-dessus peut tomber avant que le menu
        // n'ait fini sa transition (largeur/scrollbar pas encore stables).
        // On relance une fois la transition réellement terminée.
        mainNavBar.addEventListener('transitionend', function onTransitionEnd(e) {

            if (e.target !== mainNavBar || e.propertyName !== 'transform') {
                return;
            }

            mainNavBar.removeEventListener('transitionend', onTransitionEnd);

            document.dispatchEvent(new Event('links:refresh'));

        });

    }

    function registerEvents() {
    
        mainTrigger.addEventListener('click', e => {
    
            const isOpen = mainTrigger.getAttribute('aria-expanded') === 'true';

            toggleMenu(isOpen);
    
        });

        window.addEventListener('keydown', e => {

            if (e.key === 'Escape' && document.body.classList.contains('menu-active')) {

                toggleMenu(true);

            }

        });

        document.body.addEventListener('click', e => {

            const target = e.target;

            if (
                document.body.classList.contains('menu-active')
                && target.closest('body > header, body > main, body > footer')
                && !target.closest('a, button')
            ) {

                toggleMenu(true);

            }


        });
    
    };

    function calculateMainNavHeight() {

        const height = mainTrigger.offsetHeight || Math.round(mainTrigger.getBoundingClientRect().height);

        document.documentElement.style.setProperty('--main-nav-bar--height', `${height}px`);

    }

    function syncHomeHeaderState() {

        if (!document.body.classList.contains('page-home') || !homeHeader || !mainTrigger) {
            document.body.classList.remove('is-home-header-active');
            return;
        }

        const navHeight = mainTrigger.offsetHeight || Math.round(mainTrigger.getBoundingClientRect().height) || 0;
        const headerBottom = homeHeader.getBoundingClientRect().bottom;
        const isHomeHeaderActive = headerBottom > navHeight;

        document.body.classList.toggle('is-home-header-active', isHomeHeaderActive);

    }

    function registerSizeObservers() {

        const syncHeight = () => {

            requestAnimationFrame(calculateMainNavHeight);
            requestAnimationFrame(syncHomeHeaderState);

        };

        syncHeight();

        window.addEventListener('load', syncHeight);
        window.addEventListener('resize', syncHeight);

        if (document.fonts?.ready) {

            document.fonts.ready.then(syncHeight);

        }

        if (typeof ResizeObserver !== 'undefined') {

            const observer = new ResizeObserver(syncHeight);

            observer.observe(mainTrigger);

        }

    }

    function registerScrollEvents() {

        let lastScrollY = window.scrollY;
        const threshold = 10; // évite les micro-mouvements

        window.addEventListener('scroll', () => {

            const currentScrollY = window.scrollY;

            if (Math.abs(currentScrollY - lastScrollY) < threshold) {
                return;
            }

            if (currentScrollY > lastScrollY) {

                mainNavBar.classList.remove('active');

            } else {

                mainNavBar.classList.add('active');

            }

            lastScrollY = currentScrollY;

            syncHomeHeaderState();

        });

        syncHomeHeaderState();

    }

    function registerSubMenuEvents() {

        mainNavBar.querySelectorAll('button[aria-expanded][aria-controls]')?.forEach(trigger => {

            const subMenu = trigger.parentElement.querySelector(':scope > .submenu');

            if (!subMenu) return;

            let height = subMenu.offsetHeight;
            subMenu.style.setProperty('--height', 0);

            let left = subMenu.getBoundingClientRect().left;
            subMenu.style.setProperty('--left', `${left * -1}px`);

            trigger.addEventListener('click', e => {

                const open = trigger.getAttribute('aria-expanded') == 'true';

                subMenu.classList.toggle('active', !open);

                // - Close
                if (open) {

                    // subMenu.setAttribute('hidden', '');
                    trigger.setAttribute('aria-expanded', 'false');
                    subMenu.style.setProperty('--height', 0);

                } 
                // - Open
                else {

                    subMenu.removeAttribute('hidden');
                    trigger.setAttribute('aria-expanded', 'true');
                    subMenu.style.setProperty('--height', `${height}px`);

                }

            });

        });

    }

    /***********************
     * Init
     */

    // alert('jere');

    registerEvents();

    registerSubMenuEvents();

    calculateMainNavHeight();

    registerSizeObservers();

    registerScrollEvents();

}
